enum DispatchedEvents {
	GEOTARGETING_MICROSERVICE_LOADED = 'geotargeting_microservice_loaded',
	GEOTARGETING_SAVED = 'geotargeting_saved',
	GEOTARGETING_START_UP = 'geotargeting_start_up'
}

export { DispatchedEvents }
